import { useTranslation } from 'react-i18next';

// #78/I3 (Task 3): Die "kein Treffer"-Leermeldung der Katalog-Suche stand bisher an fuenf
// Stellen als eigene JSX-Kopie (E2E-, Glossar-, Testdaten-, Simplifications-Tab, Prozessbaum) mit
// drei leicht unterschiedlichen Klassenkombinationen. Hier vereinheitlicht — der Aufrufer liefert
// weiterhin sein eigenes Spacing ueber `className`, weil die fuenf Container unterschiedliche
// Abstands-Strategien fahren (space-y-N vs. einzelnes mb-N vs. p-N): das darf sich durch die
// Vereinheitlichung nicht sichtbar aendern.
//
// I3: diese Meldung steht IMMER NEBEN der Tabelle/dem Baum, nie an ihrer Stelle — sonst
// unmountet CatalogTable bei null Treffern und reisst einen offenen Bearbeiten-Entwurf
// kommentarlos mit. #78: "Kein Treffer" bleibt trotzdem eine benannte Leermeldung mit dem
// gesuchten Begriff, keine stillschweigend leere Tabelle.
export function SearchEmptyNotice({ query, className }: { query: string; className?: string }) {
  const { t } = useTranslation();
  const classes = className ? `text-sm text-text-muted ${className}` : 'text-sm text-text-muted';
  return <div className={classes}>{t('catalog.search.noResults', { query })}</div>;
}
